import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";
import { Popover } from "@mui/material";

export const BaseStyledChipPopover = styled(Popover)<{
  popoverWidth: number;
  minWidth?: number;
}>`
  .header-title {
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    min-height: 48px;
  }

  .MuiPaper-root {
    padding: 16px;
    margin-top: 8px;
    border-radius: 4px;
    ${(props) => (props.minWidth ? `min-width: ${props.minWidth}px;` : "")};
    width: ${(props) => props.popoverWidth}px;
    border: 1px solid ${COLORS.cirrus_black5};
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.25);

    ${responsive.MOBILE`
        white-space: nowrap;      
        overflow-y: hidden; 
        max-height: none;  
        overflow-x: auto;
    `}
  }

  .max-width {
    max-width: 250px;
    line-height: 27px;
  }

  .ellipses-title {
    color: ${COLORS.cirrus_black};
    line-height: 20px;
  }

  .close-icon {
    color: ${COLORS.primary_light_blue};
  }

  .text-color {
    color: ${COLORS.cirrus_black};
  }

  .full-width {
    width: 100%;
  }

  .list-item-view {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
    min-height: 60px;
    background-color: ${COLORS.cirrus_black1};
    margin-bottom: 16px;
    border-radius: 4px;
  }
`;
